var _circle, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSouthSudan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m492.029 156.753c-38.769-92.091-129.841-156.753-236.029-156.753-70.694 0-134.687 28.659-181.011 74.989l64.11 81.764z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m139.826 354.32-64.837 82.691c46.324 46.33 110.317 74.989 181.011 74.989 106.546 0 197.878-65.094 236.424-157.68z",
    fill: "#496e2d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m55.652 188.29v134.492h447.53c5.742-21.291 8.818-43.675 8.818-66.782 0-23.442-3.158-46.142-9.061-67.71z",
    fill: "#a2001d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m74.98 74.98c-99.974 99.974-99.974 262.065 0 362.04 41.313-41.313 81.046-81.046 181.02-181.02z",
    fill: "#0052b4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m83.386 192.352 31.245 43.601 51.128-16.245-31.811 43.193 31.245 43.603-50.908-16.907-31.812 43.192.35-53.643-50.91-16.909 51.124-16.244z",
    fill: "#ffda44"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthSudan);
export default __webpack_public_path__ + "static/media/southSudan.45e8181d0924598b37e34726138ca380.svg";
export { ForwardRef as ReactComponent };